import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../../http";
import Spinner from "../../Spinner";
import { capitalize } from "@mui/material";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import HeaderWrapper from "../../Header/HeaderWrapper";
import FooterWrapper from "../../Footer/FooterWrapper";
import TextMainBannerWrapper from "../../TextMainBanners/TextMainBannerWrapper";

// ✅ Convert HTML to plain text
const htmlToText = (html = "") => {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
  } catch {
    return (html || "").replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
  }
};

// ✅ Make excerpt with ellipsis only if needed
const makeExcerpt = (html = "", limit = 90) => {
  const text = htmlToText(html);
  if (text.length <= limit) {
    return { excerpt: text, isLong: false };
  }
  const cut = text.slice(0, limit).trimEnd();
  return { excerpt: `${cut}…`, isLong: true };
};

function CommentBlockReviewPage() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [reviewsData, setReviewsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    window.scrollTo(0, 0);
    getReviewsData();

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getReviewsData = async () => {
    try {
      setIsLoading(true);
      const response = await SendPostRequest("reviews");
      if (Array.isArray(response?.data) && response?.data.length > 0) {
        setReviewsData(response.data);
      } else {
        setReviewsData([]);
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setReviewsData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowMore = (review) => {
    setSelectedReview(review);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedReview(null);
  };

  return (
    <div className="page-wrapper-inner">
      <HeaderWrapper />
      <TextMainBannerWrapper Heading="Reviews" Image="theme-2-banner-review.webp"/>

      <div className="container">
        <h2 className="my-5 text-center">
          {isLoading
            ? ""
            : reviewsData?.length === 0
            ? "No Record Available"
            : "WHAT PATIENTS ARE SAYING"}
        </h2>

        <div className="row testimonails" data-animation="fadeInRight">
          {isLoading ? (
            <div className="d-flex align-items-center justify-content-center w-100">
              <Spinner />
            </div>
          ) : reviewsData?.length === 0 ? (
            <div className="d-flex align-items-center justify-content-center w-100"></div>
          ) : (
            reviewsData.map((data, index) => {
              const limit = isMobile ? 999999 : 90;
              const { excerpt, isLong } = makeExcerpt(data?.detail, limit);

              return (
                <div
                  key={index}
                  className="col-lg-4 testimonial-style-5 dark-switch item mb-5"
                >
                  <div
                    className="client-box text-left"
                    style={{ width: "85%", maxWidth: "100%" }}
                  >
                    <div className="client-image">
                      <img
                        className="img-circle img-thumbnail"
                        src={data?.profile_image || "/assets/img/no-image.png"}
                        alt={data?.name || "reviewer"}
                        style={{ width: "65px", height: "auto" }}
                        width="65"
                        height="65"
                      />
                    </div>

                    <p className="mb-2">
                      {excerpt}
                      {isLong && (
                        <Link
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleShowMore(data);
                          }}
                          className="fw-bold ms-1"
                        >
                          See More
                        </Link>
                      )}
                    </p>

                    <div className="client-details">
                      <strong className="theme-color mb-2">{data?.name}</strong>
                      <span>{data?.position}</span>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      {/* ✅ Modal with full HTML detail */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Review Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedReview && (
            <div
              dangerouslySetInnerHTML={{
                __html: selectedReview?.detail || "",
              }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="btn btn-default" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <FooterWrapper />
    </div>
  );
}

export default CommentBlockReviewPage;
